import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import { useNavigate } from "react-router-dom";
import CustomerDetailsContext from "./context";
import useAlert from "../../../../globalComponents/useAlerts";

export const useCustomerDetailsManager = (customerId) => {
  const navigate = useNavigate();
  const { showLoading, showAlert, dismissLoading } = useAlert();
  const [loading, setLoading] = useState(true);

  const [customer, setCustomer] = useState({
    name: "",
    phone: "",
    document: "",
    email: "",
    birthDate: "",
    address: {
      street: "",
      number: "",
      complement: "",
      reference: "",
      neighborhood: "",
      zipCode: "",
      city: "",
      state: "",
    },
  });

  const [balances, setBalances] = useState({
    totalEarned: 0,
    totalRedeemed: 0,
    balance: 0,
  });

  const getCustomer = async () => {
    try {
      const data = await axios.get("/customers/" + customerId);

      setCustomer((c) => ({ ...c, ...data }));
    } catch (err) {
      showAlert({
        title: "Erro",
        description: "Verifique os parâmetros enviados e tente novamente.",
        onClose: () => navigate("./../"),
      });
    } finally {
      setTimeout(() => setLoading(false), 1500);
    }
  };

  const updateCustomer = useCallback(async (form, cb) => {
    try {
      showLoading();

      const data = await axios.put("/customers/" + customerId, form);

      setCustomer((c) => ({ ...c, ...data }));
      if (typeof cb === "function") cb();

      await sleep(1000);

      showAlert({
        title: "Concluído",
        description: "Informações atualizadas com sucesso",
      });
    } catch (err) {
      showAlert({ title: "Houve um erro", description: err.message });
    } finally {
      dismissLoading();
    }
  }, []);

  const getBalances = useCallback(async () => {
    try {
      const data = await axios.get("/customers/" + customerId + "/balances");

      setBalances({ ...data });
    } catch (err) {
      showAlert({
        title: "Erro",
        description:
          "Não foi possível obter saldos de pontos. Verifique os parâmetros enviados e tente novamente.",
      });
    }
  }, []);

  useEffect(() => {
    Promise.all([getCustomer(), getBalances()]);
  }, []);

  return {
    loading,
    customer,
    balances,
    updateCustomer,
    updateBalances: getBalances,
  };
};

export const useCustomerDetails = () => useContext(CustomerDetailsContext);
